<template>
  <form v-on:submit.prevent="update()">
    <md-card>
      <md-card-header :data-background-color="dataBackgroundColor">
        <div class="md-layout md-gutter">
          <div class="md-layout-item d-size-90">
            <h4 class="title">Editar</h4>
          </div>
          <div class="md-layout-item md-size-10">
            <md-button class="md-button" @click="$router.go(-1)"
              >Volver</md-button
            >
          </div>
        </div>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>N° Factura</label>
              <md-input
                v-model="Pedido.num_factura"
                type="number"
                disabled
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Nombre</label>
              <md-input v-model="Pedido.nombre" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <md-field maxlength="3">
              <label>Pedido</label>
              <md-textarea v-model="Pedido.descripcion"></md-textarea>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Telefono</label>
              <md-input v-model="Pedido.telefono" type="tel"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Seña</label>
              <md-input
                v-model="Pedido.sena"
                type="number"
                step="0.01"
                min="0.00"
                disabled
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Total a pagar</label>
              <md-input
                v-model="Pedido.precio_total"
                type="number"
                step="0.01"
                min="0.00"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-datepicker v-model="Pedido.fecha">
              <label>Dia</label>
            </md-datepicker>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label></label>
              <label>Hora</label>
              <md-input v-model="Pedido.hora" type="time"></md-input>
            </md-field>
            <div class="md-layout-item md-size-100 text-right">
              <md-button type="submit" class="md-raised md-success"
                >Modificar</md-button
              >
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import axios from "axios";
import Global from "../../Global";
import Pedido from "../../models/pedido";
export default {
  name: "DetalleShow",
  props: {
    dataBackgroundColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      url: Global.url,
      Pedido: new Pedido("", "", "", "", "", "", "", "", "")
    };
  },
  mounted() {
    var id_pedido = this.$route.params.id;
    axios
      .get(this.url + "pedido/" + id_pedido, {
        headers: { ApiToken: localStorage.usertoken }
      })
      .then(res => {
        this.Pedido = res.data;
      });
  },
  methods: {
    update() {
      var id_pedido = this.Pedido.id;
      axios
        .put(this.url + "pedido/" + id_pedido, this.Pedido, {
          headers: { ApiToken: localStorage.usertoken }
        })
        .then(Response => {
          if (Response.status == 200) {
            this.$router.push("/pedidos");
          }
        })
        .catch(error => {
          alert(error);
        });
    }
  }
};
</script>
<style></style>
